const ProgressCircle = ({percent=100}) => {
    //const width = 295.31
    const value = ((295.31 * percent) / 100).toFixed(2)

    return (
        <svg className="progress-circle" viewBox="0 0 100 100">
            <path className="ant-progress-circle-trail"
                  d="M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94"
                  stroke="#f3f3f3"
                  style={{
                      strokeDasharray: "295.31px, 295.31px",
                      strokeDashoffset: "0px",
                      strokeWidth:"6",
                      fillOpacity:"0",
                      transition: "stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s ease 0s"
                  }}

            />
            <path
                className="ant-progress-circle-path"
                d="M 50,50 m 0,-47 a 47,47 0 1 1 0,94 a 47,47 0 1 1 0,-94"
                stroke="#108ee9"
                style={{
                    strokeDasharray: value + "px, 295.31px",
                    strokeLinecap: "round",
                    strokeWidth:"6",
                    fillOpacity:"0",
                    strokeDashoffset: "0px",
                    transition: "stroke-dashoffset 0.3s ease 0s, stroke-dasharray 0.3s ease 0s, stroke 0.3s ease 0s, stroke-width 0.06s ease 0.3s"
                }}
            />
        </svg>)
}

export default ProgressCircle